import { render, staticRenderFns } from "./document-tabs.vue?vue&type=template&id=3ae54920"
import script from "./document-tabs.vue?vue&type=script&lang=js"
export * from "./document-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports